import _ from 'lodash'
import wAxios from '@/plugins/w/axios/models/axios'
import { buildQueryFilters, createApiHook } from '@/plugins/app/api'

export interface RequestsFilters {
	search?: string
	updated_from?: string
	updated_to?: string
	payment_gate?: string[]
	payment_state?: string[]
}

export const QUERY_KEY = 'requests'

export const DEFAULT_FILTERS: RequestsFilters = {
	search: '',
	updated_from: '',
	updated_to: '',
	payment_gate: [],
	payment_state: []
}

export const fetchFn = async (pagination: Pagination, filters: RequestsFilters = {}) => {
	const query = fetchQuery(pagination, filters)

	return wAxios
		.post_auth(`v2/orders/unfinished-list`, query)
		.catch(error => Promise.reject(error.response || error))
	// return wAxios.post_auth(`v2/orders/unfinished`, query).catch((error) => Promise.reject(error.response || error))
}

export const fetchQuery = (pagination: Pagination, filters: RequestsFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)

	const query = {
		per_page: Number(pagination.per_page),
		page: Number(pagination.current_page),
		search: filtersWithDefaults.search?.trim() || '',
		updated_from: filtersWithDefaults.updated_from || '',
		updated_to: filtersWithDefaults.updated_to || '',
		payment_gate: filtersWithDefaults.payment_gate || [],
		payment_state: filtersWithDefaults.payment_state || []
	}

	return query
}

export const useGetRequests = createApiHook(fetchFn, QUERY_KEY, fetchQuery)
